import { type AppEnvT } from '@ruminati/types_v2/env'

export function isNewStandardsReportingEnabled(appEnv: AppEnvT): boolean {
  return appEnv === 'local' || appEnv === 'dev' || appEnv === 'test'
}
